var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSync({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_17_19237)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0098 4V1L8.00977 5L12.0098 9V6C15.3198 6 18.0098 8.69 18.0098 12C18.0098 13.01 17.7598 13.97 17.3098 14.8L18.7698 16.26C19.5498 15.03 20.0098 13.57 20.0098 12C20.0098 7.58 16.4298 4 12.0098 4ZM12.0098 18C8.69977 18 6.00977 15.31 6.00977 12C6.00977 10.99 6.25977 10.03 6.70977 9.2L5.24977 7.74C4.46977 8.97 4.00977 10.43 4.00977 12C4.00977 16.42 7.58977 20 12.0098 20V23L16.0098 19L12.0098 15V18Z",
    fill: "#323232"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_17_19237"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSync);
export default __webpack_public_path__ + "static/media/sync.66bc91a68cc95428323dfe6135fd0f17.svg";
export { ForwardRef as ReactComponent };